import { render } from "./AvgAnswerTimeCard.vue?vue&type=template&id=47b5a343"
import script from "./AvgAnswerTimeCard.vue?vue&type=script&lang=js"
export * from "./AvgAnswerTimeCard.vue?vue&type=script&lang=js"
script.render = render

export default script